import { makeAutoObservable } from 'mobx';
import { ICredentialsStore } from '../../integration-store';
import { IGlobalECredentialsModel } from '../../../../../../models/IntegrationsTypes';

class GlobalECredentialsStore implements ICredentialsStore {
    private _changes: IGlobalECredentialsModel = {} as IGlobalECredentialsModel;

    constructor() {
        makeAutoObservable(this, {}, { autoBind: true });
    }
    public get baseApiUrl() { return this._changes.base_api_url; };
    public get apiUsername() { return this._changes.api_username; };

    setBaseApiUrl(value: string) {
        this._changes.base_api_url = value;
    };

    setApiUsername(value: string) {
        this._changes.api_username = value;
    };

    /** ICredentialsStore implementation ************/
    public async getCredentials() {
        return { ...this._changes };
    }
}

export default GlobalECredentialsStore;
